<script lang="ts">
  import Page from '$components/page/Page.svelte';
  import Button from '$components/button/Button.svelte';
  import { getLegacySafeAddress, isLegacySafeVersion } from '$services/wallet/migrateSafeWallet';
  import type { Address } from '$types/address';
  import { type AppError, ErrorType } from '$types/error';
  import Image from '$lib/assets/safe-migration-header.webp';
  import { showToast } from '$components/toast-manager';
  import { stateError } from '$states/error.svelte';
  import { goToTransition } from '$utils/goToTransition';

  const logOut = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    goToTransition('left', '/migrate-domain');
  };

  let isLoading = $state(false);

  const logInToLegacy = async () => {
    isLoading = true;
    try {
      const legacySafeAddress = await getLegacySafeAddress();

      if (!legacySafeAddress) throw new Error('No legacy safe address found');

      const isLegacy = await isLegacySafeVersion(legacySafeAddress);
      if (!isLegacy) {
        showToast('default', 'You are already on Safe 1.4.1 version');
        void goToTransition('right', '/migrate-safe/inactive-passkey');
      } else {
        window.localStorage.setItem('legacySafeAddress', legacySafeAddress as Address);
        void goToTransition('right', '/migrate-safe');
      }
    } catch (error) {
      stateError.set({
        type: ErrorType.MODAL,
        rawError: error as AppError,
        message: `Error logging in to legacy safe:${error}`,
      });
    }
    isLoading = false;
  };
</script>

<Page>
  {#snippet middle()}
    <div class="h-[370px]">
      <img src={Image} alt="Metri" class="h-full w-full object-cover" />
    </div>
    <div class="p-gno-page">
      <h3 class="typography-l-semibold">Migrate to a newer Safe version</h3>
      <div class="text-brand">
        <p class="my-4">
          This migration will keep only your current Passkey; <span class="typography-l-semibold"
            >other Passkeys owners of your account will be deactivated.</span>
        </p>
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="grid gap-3 p-gno-page">
      <Button ariaLabel="Log Out" variant="plain" onclick={logOut}>Log Out</Button>
      <Button
        ariaLabel="Select a Passkey"
        variant="primary"
        pending={isLoading}
        onclick={logInToLegacy}>
        Select a Passkey
      </Button>
    </div>
  {/snippet}
</Page>
